import * as React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import PPIInvestmentProjectFormComponent from './project-form-component';
import * as actions from '../../../../actions';
import PPIInvestmentProjectService from '../../../../service/sfp/ppi-investment-project-service';

class InvestmentProjectFormContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: undefined, 
			submitting: false,
			name: ""
		};
	}

	componentDidMount() {
		if (this.props.project) {
			this.setState({
				theme: this.props.theme ? this.props.theme.id : undefined,
				subtheme: this.props.subtheme ? this.props.subtheme.id : undefined,
				name: this.props.project.name, 
				description: this.props.project.description,
				accounting_article: this.props.project.accounting_article,
				operation_number: this.props.project.operation_number, 
				priority: this.props.project.priority,
				fctva: this.props.project.fctva
			})
		} else {
			this.setState({
				theme: this.props.theme.parent ? this.props.theme.parent.id : this.props.theme.id,
				subtheme: this.props.theme.parent ? this.props.theme.id : null
			})
		}
	}

	render() {
		return (
			<PPIInvestmentProjectFormComponent
				themes							= {this.props.ppi.investment_themes}
				theme								= {this.state.theme}
				subtheme						= {this.state.subtheme}
				name								= {this.state.name}
				description					= {this.state.description}
				accounting_article	= {this.state.accounting_article}
				operation_number		= {this.state.operation_number}
				priority						= {this.state.priority}
				fctva								= {this.state.fctva}
				delete							= {this.props.delete}
				onThemeChange				= {(e) => {this.setState({theme: e.target.value})}}
				onSubThemeChange		= {(e) => {this.setState({subtheme: e.target.value})}}
				onNameChange				= {(e) => {e.constructor === String ?this.setState({name: e}):this.setState({name: e.target.value})}}
				onDescriptionChange = {(e) => {this.setState({description: e.target.value})}}
				onAccountingArticleChange = {(e) => {this.setState({accounting_article: e.target.value})}}
				onOperationNumberChange = {(e) => {this.setState({operation_number: e.target.value})}}
				onPriorityChange = {(e) => {this.setState({priority: e.target.value})}}
				onFctvaChange = {(e) => { this.setState({fctva: (e.target.value == "1" ? true : false)})}}
				project							= {this.props.project}
				parentTheme					= {this.props.parentTheme}
				onSubmit      			= {this._handleSubmit}
				submitting    			= {this.state.submitting}
			/>
		)
	}

	_handleSubmit = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		event.preventDefault();
		event.persist()
		this.setState({ submitting: true })

		if (this.props.delete) {
			PPIInvestmentProjectService.deletePPIInvestmentProject(this.props.project.id)
				.then(this._resolveDeleteInvestmentProject.bind(this, event), this._rejectDeleteInvestmentProject)
		} else {
			const ppi_project = {
				theme: this.state.subtheme ? this.state.subtheme : this.state.theme,
				name: event.target.name.value,
				description: event.target.description.value,
				accounting_article: event.target.accounting_article.value,
				operation_number: event.target.operation_number.value,
				priority: event.target.priority.value,
				fctva: event.target.fctva.value == "1" ? true : false
			}

			/*
			if (!this.props.project) {
				ppi_project["theme"] = this.props.theme.id
			}
			*/

			if (this.props.project) {
				PPIInvestmentProjectService.updatePPIInvestmentProject(this.props.project.id, ppi_project)
					.then(this._resolveUpdateInvestmentProject.bind(this, event), this._rejectUpdateInvestmentProject)
			} else {
				PPIInvestmentProjectService.createPPIInvestmentProject(ppi_project)
					.then(this._resolveCreateInvestmentProject.bind(this, event), this._rejectCreateInvestmentProject)
			}
		}
	}

	_rejectCreateInvestmentProject = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveCreateInvestmentProject = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onCreated(response)
		})
		this.context.onCustomAction("alter_project", {project: response,theme:this.state.theme,subtheme:this.state.subtheme})
	}

	_rejectUpdateInvestmentProject = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveUpdateInvestmentProject = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onUpdated(response)
		})
	}

	_rejectDeleteInvestmentProject = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveDeleteInvestmentProject = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onDeleted(response)
		})
	}

}

InvestmentProjectFormContainer.contextTypes = {
	onCustomAction:React.PropTypes.function
  };

const mapDispatchToProps = dispatch => (
	{actions: bindActionCreators(actions, dispatch)}
);

export default connect(null, mapDispatchToProps)(InvestmentProjectFormContainer);



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/project-form-container.js